import { RichTextField, RichTextNodeType } from '@prismicio/client'

const TRUSTED_LINK_HOSTS = ['audur.is', 'kvika.is']

// Mirrors the audur_site_alert body config: paragraph,strong,em,hyperlink
const SUPPORTED_SPANS: string[] = [RichTextNodeType.strong, RichTextNodeType.em, RichTextNodeType.hyperlink]

/**
 * Only HTTPS links to our own domains, without credentials, so a CMS slip can't turn
 * the scam domain (or a lookalike like audur.is@evil.com) into a link.
 */
export const isTrustedAlertUrl = (url?: string) => {
	if (!url) {
		return false
	}
	try {
		const { protocol, username, password, hostname } = new URL(url)
		return (
			protocol === 'https:' &&
			!username &&
			!password &&
			TRUSTED_LINK_HOSTS.some((host) => hostname === host || hostname.endsWith(`.${host}`))
		)
	} catch {
		return false
	}
}

/**
 * Drops everything the alert model doesn't allow. Images (which can carry their own link)
 * and embeds (rendered as raw HTML) would otherwise bypass the hyperlink check.
 */
export const getSupportedAlertBody = (body: RichTextField): RichTextField | null => {
	const paragraphs = body.flatMap((node) =>
		node.type === RichTextNodeType.paragraph
			? [{ ...node, spans: node.spans.filter((span) => SUPPORTED_SPANS.includes(span.type)) }]
			: []
	)
	return paragraphs.length > 0 ? (paragraphs as RichTextField) : null
}
